/**
 * 모바일 바텀시트 높이 규칙
 *
 * 바텀시트는 내부 컨텐츠 높이에 맞춰 자동으로 커짐.
 * 상단바 하단과의 간격이 16px가 되면 더 이상 커지지 않고 내부 스크롤.
 */

// 상단바 하단과 바텀시트 상단 사이의 최소 간격
const MIN_GAP = 16;

/**
 * 바텀시트 최대 높이 계산
 *
 * @param {number} topBarHeight — 상단바 전체 높이 (px)
 * @param {number} screenHeight — 화면 전체 높이 (px)
 * @returns {number} maxHeight (px)
 */
export function calcBottomSheetMaxHeight(topBarHeight, screenHeight) {
  return screenHeight - topBarHeight - MIN_GAP;
}

export default { MIN_GAP };
